import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { itemDetailsRouteCommands } from '../item-details/item-details-routing.util';

@Injectable({
  providedIn: 'root'
})
export class OrderNavigationService {
  constructor(
    private router: Router
  ) {}

  navigateToItemDetails(orderNumber: string, state: any = {}): void {
    if (!orderNumber || orderNumber === 'New Order') {
      this.router.navigate(['/item-v2', 'new']);
      return;
    }

    this.router.navigate(itemDetailsRouteCommands('v2', orderNumber), {
      state
    });
  }
}
